import axios from "axios";
import Echo from "laravel-echo";
import ls from "localstorage-slim";
import { Component } from "react";
import { connect } from "react-redux";
import appConfig from "./config/appConfig";
import { AUTH_TOKEN } from "./constants/token";
import LoginPage from "./modules/login/views/Pages/LoginPage.jsx";
import RouteApp from "./routeApp";
import { loadPlan } from "./store/actions/planAction";
import { loadYear } from "./store/actions/yearAction";
import Loader from "./views/components/Loader";
import { BrowserRouter as Router, Route } from "react-router-dom";
import DownLoadReceipt from "./views/layouts/DownLoadReceipt.jsx";

window.Pusher = require("pusher-js");

class AppContainer extends Component {
  constructor(props) {
    super(props);
    if (ls.get("plan")) this.props.loadPlan(ls.get("plan"));
    this.state = {
      load: true,
    };

    // On initialise Echo seulement quand nécessaire
    this.echoInstance = null;
  }

  initializeEcho = () => {
    // On vérifie si Echo existe déjà globalement pour éviter les doublons
    if (window.Echo) {
      console.log("Echo already exists, disconnecting old instance");
      window.Echo.disconnect();
    }

    if (!this.echoInstance) {
      this.echoInstance = new Echo({
        broadcaster: "pusher",
        key: "e0acb5bac6ddb3b710f4",
        cluster: "mt1",
        forceTLS: false,
        wsHost: appConfig.host,
        wsPort: appConfig.port,
        disableStats: true,
        enabledTransports: ["ws", "wss"],
        activityTimeout: 30000,
        pongTimeout: 6000,
        unavailableTimeout: 10000,
        // On limite les tentatives de reconnexion
        enableStats: false,
        authEndpoint: appConfig.apiDomaine + "/api/broadcasting/auth",
        auth: {
          headers: {
            Authorization: AUTH_TOKEN,
          },
        },
      });
      window.Echo = this.echoInstance;

      // debug
      if (this.echoInstance.connector && this.echoInstance.connector.pusher) {
        this.echoInstance.connector.pusher.connection.bind("connected", () => {
          console.log("Pusher connected successfully");
        });

        this.echoInstance.connector.pusher.connection.bind(
          "disconnected",
          () => {
            console.log("Pusher disconnected");
          }
        );

        this.echoInstance.connector.pusher.connection.bind("failed", () => {
          console.log("Pusher connection failed");
        });
      }
    }
  };

  componentDidMount() {

    const currentPathname = window.location.pathname;
    const isForgotPassword = /^\/forgot-password\/[^/]+$/.test(currentPathname);
    if (isForgotPassword) {
      // Skip Echo and plan loading on public routes
      this.setState({ load: false });
      return;
    }

    // On initlialise Echo dès le début
    this.initializeEcho();

    // On crée un AbortController pour annuler la requête si nécessaire
    this.abortController = new AbortController();

    axios
    .get(`${appConfig.apiDomaine}/plan`, {
      signal: this.abortController.signal,
    })
    .then((response) => {
      this.setState({ load: false });
      ls.set("plan", response.data.plan);
      if (response.data.year_installation !== null) {
        ls.set("year_installation", response.data.year_installation);
      }
      this.props.loadPlan(response.data.plan);
      this.props.loadYear(
        response.data.year_installation !== null
          ? response.data.year_installation
          : ""
      );
    })
    .catch((error) => {
      if (error.name !== "AbortError") {
        this.setState({ load: false });
      }
    });
  }

  componentWillUnmount() {
    // On nettoie l'AbortController
    if (this.abortController) {
      this.abortController.abort();
    }

    // On nettoie Echo
    if (this.echoInstance) {
      this.echoInstance.disconnect();
      this.echoInstance = null;
      window.Echo = null;
    }
  }

  render() {
    const plan = this.props.plan;
    const load = this.state.load;

    const currentPathname = window.location.pathname;
    const regex = /^\/download-receipt\/[A-Z0-9-]+$/;
    const isMatch = regex.test(currentPathname);
    const publicForgotPassword = /^\/forgot-password\/[^/]+$/;
    const isPublicSatisfaction = publicForgotPassword.test(currentPathname);

    if (isMatch || isPublicSatisfaction) {
      return <RouteApp />;
    }

    return !plan ? load ? <Loader /> : <LoginPage /> : <RouteApp />;
  }
}

const mapStateToProps = (state) => {
  return {
    plan: state.plan.plan,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadPlan: (plan) => dispatch(loadPlan(plan)),
    loadYear: (plan) => dispatch(loadYear(plan)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);
